<template>
	<svg style="" aria-hidden="true" viewBox="0 0 48 48" class="nfc_ok">
		<rect x="8" y="12" width="32" height="24" rx="4" ry="4" stroke="#5D534B" stroke-width="none" fill="none" />
		<path d="M16 22h16m-10 6h6" stroke="#5D534B" stroke-width="2.4" stroke-linecap="round" />
		<path d="M14 28l6 6l14-14" fill="none" stroke="#2ECC71" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
	</svg>
</template>
